var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7803 9.46967C17.4874 9.17678 17.0126 9.17678 16.7197 9.46967L12 14.1893L7.28033 9.46967C6.98744 9.17678 6.51256 9.17678 6.21967 9.46967C5.92678 9.76257 5.92678 10.2374 6.21967 10.5303L11.4697 15.7803C11.7626 16.0732 12.2374 16.0732 12.5303 15.7803L17.7803 10.5303C18.0732 10.2374 18.0732 9.76256 17.7803 9.46967Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeArrow);
export default __webpack_public_path__ + "static/media/icon-tree-arrow.aef0cd687842158cd80f2d033c397750.svg";
export { ForwardRef as ReactComponent };